<div class="selector">
  <app-image-model-item *ngFor="let item of imageSelector" [imageModel]="item" (click)="selectedModel(item)"></app-image-model-item>
</div>
